import { useState } from 'react';
import { useSearchParams, Link, useLocation, useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/AuthPage.css';

const AuthPage = () => {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ username: '', email: '', password: '' });
  const mode = searchParams.get('mode') === 'signup' ? 'signup' : 'login';
  const location = useLocation();
  const navigate = useNavigate();
  const { login, signup, isAuthenticated } = useAuth();
  const returnTo = location.state?.returnTo || '/';

  if (isAuthenticated) {
    return <Navigate to={returnTo} replace />;
  }

  const handleChange = event => {
    setForm(current => ({ ...current, [event.target.name]: event.target.value }));
  };

  const handleSubmit = async event => {
    event.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      if (mode === 'signup') {
        await signup({
          username: form.username.trim(),
          email: form.email.trim(),
          password: form.password,
        });
        await login({ email: form.email.trim(), password: form.password });
      } else {
        await login({ email: form.email.trim(), password: form.password });
      }
      navigate(returnTo);
    } catch (err) {
      setError(err.userMessage || err.message || 'Authentication failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className='auth-page'>
      <div className='auth-modal'>
        <h2>{mode === 'signup' ? 'Sign Up' : 'Log In'}</h2>
        <form onSubmit={handleSubmit}>
          {mode === 'signup' && (
            <input
              type='text'
              name='username'
              placeholder='Username'
              value={form.username}
              onChange={handleChange}
              required
              minLength={3}
            />
          )}
          <input
            type='email'
            name='email'
            placeholder='Email'
            value={form.email}
            onChange={handleChange}
            required
          />
          <div className='password-input'>
            <input
              type={showPassword ? 'text' : 'password'}
              name='password'
              placeholder='Password'
              value={form.password}
              onChange={handleChange}
              required
              minLength={6}
            />
            <button
              type='button'
              className='toggle-password'
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? 'Hide' : 'Show'}
            </button>
          </div>
          {error && <p className='auth-error'>{error}</p>}
          <button type='submit' className='auth-btn' disabled={isLoading}>
            {isLoading ? 'Please wait...' : mode === 'signup' ? 'Sign Up' : 'Log In'}
          </button>
        </form>
        {mode === 'signup' ? (
          <p className='auth-switch'>
            Already have an account? <Link to='?mode=login'>Log In</Link>
          </p>
        ) : (
          <>
            <p className='auth-switch'>
              Need an account? <Link to='?mode=signup'>Sign Up</Link>
            </p>
            <Link to='/forgot-password' className='forgot-password'>
              Forgot Password?
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthPage;
